import script from "./vmsAffiliationGrid.vue?vue&type=script&lang=js"
export * from "./vmsAffiliationGrid.vue?vue&type=script&lang=js"

import "./vmsAffiliationGrid.vue?vue&type=style&index=0&id=113cd0f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-113cd0f5"]])

export default __exports__